import { ActivatedRoute } from '@angular/router';
import { LocalStorageService } from './../core/localstorage.service';
import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from "@angular/platform-browser";

@Component({
  selector: 'app-oauth-tutorial',
  templateUrl: './oauth-tutorial.component.html',
  styleUrls: ['./oauth-tutorial.component.scss']
})
export class OauthTutorialComponent implements OnInit {
  pageNames: any = [
    "App Registration",
    "Standalone",
    "SMART Backend Services",
    "EHR Launch"
  ];
  
  apiPageName: string = "app registration";
  selectedItem: any = 'App Registration';
  iFrameSrc: any;
  url: any;
  loginData: boolean = false;

  constructor(
    private domSanitizer: DomSanitizer, private localStorage: LocalStorageService, 
    private activatedRoute: ActivatedRoute
  ) {
    if(this.localStorage.getFromStorage('userDetails')){
      this.loginData = true;
     }
   }

  ngOnInit() {
    this.changePageName(this.apiPageName);
  }

  changePageName(page: string) {
    this.selectedItem = page;
    if(page == 'app registration'){
      this.apiPageName = 'client-registration'
    }else if(page == 'standalone'){
      this.apiPageName = 'standalone';
    }else if(page == 'smart backend services'){
      this.apiPageName = 'smart-backend-services';
    }else if(page == 'ehr launch'){
      this.apiPageName = 'ehr-launch';
    }
    this.url = `assets/oauth-tutorial-pages/${this.apiPageName}.html`;
    this.iFrameSrc = this.domSanitizer.bypassSecurityTrustResourceUrl(this.url);
  }

}
